export enum GameMode {
	NORMAL,
	SANDBOX,
}

const GameGlobals = {
	setSelectedEntity: undefined as any,
	selectedEntity: undefined as any,
	viewportFollow: false,
	gameMode: GameMode.SANDBOX,
}

export default GameGlobals